import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { variantsActions } from ".";
import {
  CLEAR_VARIANTS_STATE,
  FETCH_VARIANTS_LIST_PROGRESS,
  FETCH_VARIANTS_LIST_SUCCESS,
  FETCH_VARIANTS_LIST_FAILED,
} from "./variantsActions";
import { initialVariantsState } from "./defaultState";
import { IVariantsState } from "./variants.types";

export const variantsReducer = (
  state: IStoreState["variants"] = initialVariantsState,
  action: variantsActions
) => {
  switch (action.type) {
    case FETCH_VARIANTS_LIST_PROGRESS: {
      const newState = produce(state, (draftState: IVariantsState) => {
        draftState.list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_VARIANTS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState: IVariantsState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_VARIANTS_LIST_FAILED: {
      const newState = produce(state, (draftState: IVariantsState) => {
        draftState.list.loading = LoadState.Failed;
      });
      return newState;
    }
    case CLEAR_VARIANTS_STATE: {
      return initialVariantsState;
    }
    default:
      return state;
  }
};
